import { useTranslation } from 'react-i18next';
import type { Locale } from 'date-fns';
import {
  getDateFnsLocale,
  getDayjsLocale,
  getIntlDateLocale,
} from '../utils/dateLocale';
import { normalizeBookingLanguage, type BookingLanguageCode } from '../config/i18n';

export function useDateLocale() {
  const { i18n } = useTranslation();
  const language = i18n.language;

  return {
    language: normalizeBookingLanguage(language),
    intlLocale: getIntlDateLocale(language),
    dateFnsLocale: getDateFnsLocale(language) as Locale,
    dayjsLocale: getDayjsLocale(language),
  };
}

export type DateLocaleBundle = {
  language: BookingLanguageCode;
  intlLocale: string;
  dateFnsLocale: Locale;
  dayjsLocale: string;
};
